import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M0 0V10H10V0H0ZM9 9H1V1H9V9Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 3H3V7H7V3Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 0V10H23V0H13ZM22 9H14V1H22V9Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 3H16V7H20V3Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M0 13V23H10V13H0ZM9 22H1V14H9V22Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 16H3V20H7V16Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 14V13H13V23H16V22H14V19H16V17H14V14H16Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M23 13H22V14H23V13Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M22 16V22H20V23H23V16H22Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 13H17V14H20V13Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 17V16H17V20H20V19H19V17H20Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 22H17V23H19V22Z" })
	] })
});
export default SvgQrIcon;
